<template>
  <div class="page-header clear-filter" filter-color="orange">
    <div class="page-header-image" style="background-image: url('img/login.jpg')"></div>
    <div class="content">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto">
          <card type="login" plain>
            <div slot="header" class="w-50 mb-3 mx-auto">
              <img v-lazy="'img/logo2.png'" alt />
            </div>
              <TextInput
              :rules="'required|email'"
              placeholder="Company Email"
              v-model="form.company"
            />
            <TextInput
              :rules="'required'"
              placeholder="Password"
              v-model="form.password"
              type="password"
            />
           
            <p v-if="errors" class="error-block bg-red">{{errors}}</p>
            <template slot="raw-content">
              <div @click="Login" class="card-footer text-center">
                <div class="btn btn-primary btn-round btn-lg btn-block">
                  <b-spinner style="width: 20px; height: 20px;" variant="light" v-if="isLoggingIn" label="Spinning"></b-spinner>
                  <span v-else>Login</span>
                </div>
              </div>
              <div class="pull-left">
                <h6>
                  <a href="/signup" class="link footer-link">Create Account</a>
                </h6>
              </div>
              <div class="pull-right">
                <h6>
                  <a href="#pablo" class="link footer-link">Forgot password?</a>
                </h6>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
    <!-- <main-footer></main-footer> -->
  </div>
</template>
<script>
import { Card, Button } from "@/components";
import TextInput from "./components/Inputs/TextInput"
//import MainFooter from '@/layout/MainFooter';
export default {
  name: "login-page",
  bodyClass: "login-page",
  components: {
    Card,
    //MainFooter,
    [Button.name]: Button,
    TextInput
  },
  data() {
    return {
      form: {
        company: "",
        password: ""
      }
    };
  },
  methods: {
    Login() {
      this.$store.dispatch("Auth/login", this.form).then(()=>{
        //this.$router.push("/dashboard")
      })
    }
  },
  computed: {
    isLoggingIn() {
      return this.$store.state.Auth.isLoggingIn;
    },
    errors() {
      return this.$store.state.Auth.errors;
    }
  }
};
</script>
<style>
.btn-loader {
  width: auto;
  height: 20px;
}

.error-block {
  background: #f03d3d;
  font-size: 12px;
  font-weight: 500;
  border-radius: 50px;
  margin-top: 20px;
}
</style>
